import {
  adminBroadcastNotifications,
  PermissionsOfAdmin,
} from '@pharmaplan/common';

import useTableSelectCheckbox from '../../useTableSelectCheckbox';
import useAdminPermissions from '../useAdminPermissions';
import { useAppSelector } from '../../useAppSelector';

import useBroadcastNotificationActions from './useBroadcastNotificationActions';

const { BroadcastNotification } = PermissionsOfAdmin;
const userType = 'broadcastNotification';
const idProperty = 'broadcastMessageId';

const useBroadcastNotificationSelect = (page: number) => {
  const { can } = useAdminPermissions();
  const { handleMultipleDelete } = useBroadcastNotificationActions();

  const { data } = useAppSelector(adminBroadcastNotifications) ?? {};

  const {
    handlePress,
    selectAllFunc,
    selectedIds,
    selectAll,
    allIds,
    handleReset,
  } = useTableSelectCheckbox({
    page,
    useOfEdit: false,
    userType,
    dataLength: data?.length ?? 0,
  });

  return {
    canSelect: can(BroadcastNotification),
    handlePress,
    selectedIds,
    selectAll,
    selectAllFunc: selectAllFunc({ data: data ?? [], idProperty }),
    selectedCount: allIds.length,
    handleDelete: handleMultipleDelete(allIds),
    handleReset,
  };
};

export default useBroadcastNotificationSelect;
